export default "__VITE_ASSET__CEq7sJ5D__"